import "../styles/news-area.scss";
import React from "react";

function NewsArea() {

  return (
    <section className="main__news-area">
		<h2><em>Forever High</em> now streaming everywhere!</h2>
		<iframe title="Feels Like The Last Time" src="https://bandcamp.com/EmbeddedPlayer/album=3854407252/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://crimsondevils.bandcamp.com/album/forever-high">Feels Like The Last Time by Crimson Devils</a></iframe>
    </section>
  )
}

export default NewsArea
